import React, {Component} from 'react';
import PageTemplate from 'components/common/PageTemplate';
import PlusUpContainer from 'containers/guide/PlusUpContainer';

import { Helmet, HelmetProvider } from "react-helmet-async";

// import Adsense970250 from 'components/adsense/Adsense970250';


class PlusUpPage extends Component {
  render() {
    return (
      <PageTemplate>
        <HelmetProvider>
          <Helmet>
            <title>이터널시티 플러스업</title>
            <meta name="description" content="플러스업 강화별 증가치" />
          </Helmet>
        </HelmetProvider>
        {/* <Adsense970250/> */}
        <PlusUpContainer/>
      </PageTemplate>
    );
  }
};

export default PlusUpPage;